// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ButtonGroup = theme => {
  return {
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: 'none'
        }
      }
    }
  };
};

export { ButtonGroup };
